<template>
  <div id="app">
    <AuthenticationForm>
      <div slot="form-title">
        <h5 class="text-center">Reset the password</h5>
      </div>

      <div slot="form">
        <b-form @submit.prevent>
          <div v-if="step === 1">
            <b-alert
              v-model="showDismissibleAlert"
              variant="danger"
              dismissible
            >Email Does not Exists</b-alert>
            <h6>Enter the email address that you logged in with.</h6>
            <b-form-group label-for="email">
              <b-form-input
                id="email"
                type="email"
                v-model="email"
                required
                placeholder="Enter your Email Address"
              ></b-form-input>
              <p v-if="errors.email" class="errors">{{ errors.email }}</p>
            </b-form-group>

            <div class="col-md-12 text-center">
              <b-button type="submit" variant="amej-button" @click.prevent="next()">Next</b-button>
            </div>
          </div>

          <transition name="fade">
            <div v-if="step === 2">
              <b-alert v-model="showDismissibleAlert1" variant="danger" dismissible>
                <div v-if="message">
                  <p v-if="message.length>0">{{message}}</p>
                </div>
              </b-alert>
              <b-form-group label-for="code">
                <h6>Enter the verification code that you got on your mail.</h6>
                <b-form-input
                  id="code"
                  type="text"
                  maxlength="7"
                  v-model="token"
                  placeholder="Enter the code here"
                  onkeypress="if(this.value.length==7) return false;"
                ></b-form-input>
                <p v-if="errors.token" class="errors">{{ errors.token }}</p>
              </b-form-group>

              <h6>Enter the new password.</h6>
              <b-form-group label-for="new-password">
                <b-form-input
                  id="new-password"
                  type="password"
                  v-model="password"
                  placeholder="Enter New Password"
                ></b-form-input>
                <p
                  v-if="errors.password || errors.strongpasword"
                  class="errors"
                >{{ errors.password }} {{errors.strongpasword}}</p>
              </b-form-group>

              <h6>Repeat the password</h6>
              <b-form-group label-for="repeat-password">
                <b-form-input
                  id="repeat-password"
                  type="password"
                  v-model="confirm_password"
                  placeholder="Repeat Password"
                ></b-form-input>
                <p v-if="errors.confirm_password" class="errors">{{ errors.confirm_password }}</p>
                <p v-if="errors.wrongpassword" class="errors">{{ errors.wrongpassword }}</p>
              </b-form-group>

              <div class="col-md-12 text-center">
                <b-button
                  type="submit"
                  variant="amej-button"
                  @click="handleResetPasswordForm"
                >Reset Password</b-button>
              </div>
            </div>
          </transition>
        </b-form>
      </div>
    </AuthenticationForm>
  </div>
</template>

<script>
import { mapState, mapMutations } from "vuex";
import AuthenticationForm from "../login_components/AuthenticationForm";

export default {
  name: "ForgotPassword",
  components: {
    AuthenticationForm: AuthenticationForm,
  },
  computed: {
    ...mapState([
      "step",
      "message",
      "passwordmessage",
      "successmessage",
      "errormessage",
    ]),
  },
  data() {
    return {
      email: "",
      token: "",
      password: "",
      confirm_password: "",
      errors: [],
      wrongpassword: "",
      strongpasword: "",
      showDismissibleAlert: false,
      showDismissibleAlert1: false,
    };
  },

  watch: {
    password(value) {
      this.password = value;
      this.check_password(value);
    },
  },

  methods: {
    ...mapMutations(["setToken"]),

    check_password(value) {
      if (/^(?=.*[a-z])(?=.*\d)(?=.*[^\da-zA-Z]).{8,15}$/.test(value)) {
        this.errors["strongpasword"] = "";
      } else {
        this.errors["strongpasword"] = "Enter strong password.";
      }
    },

    next() {
      this.errors = [];
      if (this.email == "") {
        this.errors["email"] = "Email required.";
      } else {
        this.$store
          .dispatch("forgetpassword", {
            email: this.email,
          })
          .then(() => {
            if (this.stepincrease == "true") {
              this.step++;
            } else if (this.errormessage == "errormessage") {
              this.showDismissibleAlert = true;
              this.$router.replace("/forgotpassword");
            }
          });
      }
    },
    handleResetPasswordForm() {
      this.errors = [];
      if (this.token == "") {
        this.errors["token"] = "Token required.";
      } else if (this.password == "") {
        this.errors["password"] == "Password required.";
      } else if (this.confirm_password == "") {
        this.errors["confirm_password"] = "Confirm Password required.";
      } else if (this.password != this.confirm_password) {
        this.errors["wrongpassword"] = "Password do not match.";
      } else {
        this.$store
          .dispatch("resetpassword", {
            token: this.token,
            password: this.password,
            confirm_password: this.confirm_password,
          })
          .then(() => {
            if (this.successmessage == "success") {
              this.$router.replace("/");
            } else if (this.passwordmessage == "passwordmessage") {
              this.showDismissibleAlert1 = true;
              this.$router.replace("/forgotpassword");
            }
          });
      }
    },
  },
};
</script>

<style lang="scss" scoped>
  @import '../../css/style.scss';

.fade-enter-active,
.fade-leave-active {
  transition: all 1s;
}

.fade-enter,
.fade-leave-to {
  opacity: 0;
  transform: translateY(30px);
}
</style>
